import React from 'react'
import { useTranslation } from 'react-i18next'
import { BaseView } from '@/components/base'
import { Modal } from '@/components/Modal'
import {
  CurrencyItem,
  CurrencyItemProps,
} from '../../select-currency/components/CurrencyItem'
import { useCurrencySelection } from '../../select-currency/hooks/useCurrencySelection'
import { useAddMoneyStore } from '@/store/useAddMoneyStore'

interface CurrencyBottomSheetProps {
  isOpen: boolean
  onClose: () => void
}

export const CurrencyBottomSheet: React.FC<CurrencyBottomSheetProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation()
  const { currencies } = useCurrencySelection()
  const { setSelectedCurrency } = useAddMoneyStore()

  const handleCurrencySelect = (currency: CurrencyItemProps) => {
    // Update selected currency in store with full data
    setSelectedCurrency({
      id: currency.id,
      code: currency.code,
      name: currency.name,
      icon: currency.icon,
      label: currency.label || '$',
      avatarBGRefColor: currency.avatarBGRefColor,
      pricePerUnit: currency.pricePerUnit || 1,
      symbol: currency.symbol || currency.code,
      displayCurrencyCode: currency.displayCurrencyCode || currency.code,
      formattedUSDBalance: currency.formattedUSDBalance || '$0.00',
      formattedAmountBalance: currency.formattedAmountBalance || '0',
      formattedFiatBalance: currency.formattedFiatBalance || '$0.00',
      formattedStablecoinBalance: currency.formattedStablecoinBalance || '0',
      amount: currency.amount || 0,
      amountWithoutNumberConversion:
        currency.amountWithoutNumberConversion || '0',
      fiatAmount: currency.fiatAmount || 0,
      fiatCurrency: currency.fiatCurrency || 'USD',
      usdBalance: currency.usdBalance || 0,
      ceilingValueForValidation: currency.ceilingValueForValidation || 0,
      availableOnRampPaymentMethods: currency.availableOnRampPaymentMethods || [
        'card',
      ],
    })

    // Close the modal
    onClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('screens:addMoney.selectCurrency')}
      showHandle={true}
    >
      <BaseView
        style={{
          gap: 12,
          paddingBottom: 20,
          scrollbarWidth: 'none',
        }}
      >
        {currencies.map((currency) => (
          <CurrencyItem
            key={currency.id}
            {...currency}
            onPress={() => handleCurrencySelect(currency)}
          />
        ))}
      </BaseView>
    </Modal>
  )
}
